module.exports = __webpack_public_path__ + "img/fileIcon.1b7cc532.png";